<template>
  <div>
    <new-perseu-card title="Plano Principal">
      <div class="body-1">
        <template v-if="!isMainPlanPastRenewal">
          <!-- Layout responsivo para mobile e desktop -->
          <div
            class="d-flex flex-column flex-md-row align-center justify-space-between mx-2 mx-md-4 my-4 my-md-8"
          >
            <!-- Informações do plano -->
            <div
              class="d-flex flex-column flex-md-row align-center align-md-start text-center text-md-left mb-4 mb-md-0 ml-md-4 full-width-mobile"
            >
              <div class="flex-grow-1" style="min-width: 330px">
                <div
                  class="font-weight-bold text-h6 text-md-h6 text-sm-subtitle-1"
                >
                  {{ subscriptionData.planName }}
                </div>
                <div v-if="!subscriptionData.isManualSubscription" class="mt-1">
                  <b>{{
                    isMainPlanTrialing
                      ? subscriptionData.planPrice
                      : subscriptionData.lastPrice
                  }}</b
                  >/mês
                </div>
                <div class="body-2 pt-2">
                  {{
                    !subscriptionData.isManualSubscription
                      ? isMainPlanTrialing
                        ? "Início avaliação:"
                        : "Início Assinatura:"
                      : "Início vigência:"
                  }}
                  {{ subscriptionData.createdAt | formatDateFriendly }}
                </div>
                <div class="body-2 font-weight-medium">
                  {{
                    !subscriptionData.isManualSubscription
                      ? isMainPlanCancelled || isMainPlanExpired
                        ? "Acesso liberado até:"
                        : isMainPlanTrialing
                        ? "Efetivação em:"
                        : "Próxima Renovação:"
                      : "Válido até:"
                  }}
                  {{ subscriptionData.nextBillingTime | formatDateFriendly }}
                </div>
                <div
                  v-if="isMainPlanCancelled"
                  class="body-2 font-weight-medium text-bolder red--text mt-1"
                >
                  Assinatura pode ser reativada após
                  {{ subscriptionData.nextBillingTime | formatDateFriendly }}.
                </div>
              </div>
              <!-- Status chip - responsive positioning -->
              <div class="mt-3 mt-md-0 ml-md-6">
                <subscription-status-chip :status="subscriptionData.status" />
              </div>
            </div>

            <!-- Botões de ação - stack em mobile -->
            <div
              class="d-flex flex-column align-center flex-shrink-0 full-width-mobile"
            >
              <v-btn
                v-if="isMainPlanCancelled || isMainPlanExpired"
                class="mb-2"
                color="secondary"
                rounded
                elevation="3"
                :small="$vuetify.breakpoint.xs"
                :block="$vuetify.breakpoint.xs"
                :disabled="!canRenewMainSubscription"
                @click="redirectToPlansPage"
              >
                <v-icon left :small="$vuetify.breakpoint.xs"
                  >mdi-restart</v-icon
                >
                <span class="d-none d-sm-inline">Reativar plano</span>
                <span class="d-inline d-sm-none">Reativar</span>
              </v-btn>
              <v-btn
                v-if="
                  !isMainPlanCancelled &&
                  !isMainPlanExpired &&
                  !isMainPlanTrialing
                "
                class="mb-2"
                color="secondary"
                rounded
                elevation="3"
                :small="$vuetify.breakpoint.xs"
                :block="$vuetify.breakpoint.xs"
                @click="redirectToPlansPage"
              >
                <v-icon left :small="$vuetify.breakpoint.xs"
                  >mdi-swap-horizontal</v-icon
                >
                <span class="d-none d-sm-inline">Alterar plano</span>
                <span class="d-inline d-sm-none">Alterar</span>
              </v-btn>
              <v-btn
                v-if="!isMainPlanCancelled && !isMainPlanExpired"
                text
                :x-small="!$vuetify.breakpoint.xs"
                :small="$vuetify.breakpoint.xs"
                color="red lighten-3"
                class="mt-1"
                :block="$vuetify.breakpoint.xs"
                @click="cancelSubscription"
              >
                {{
                  isMainPlanTrialing
                    ? "Cancelar avaliação"
                    : "Cancelar assinatura"
                }}
              </v-btn>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="text-center body-2 pa-4 grey--text">
            Você não possui nenhum plano ativo no momento.
          </div>

          <div class="d-flex justify-center pa-2 mt-2">
            <v-btn
              rounded
              elevation="3"
              color="primary"
              @click="redirectToPlansPage"
            >
              <v-icon left>add_circle_outline</v-icon>
              Contratar Plano
            </v-btn>
          </div>
        </template>
      </div>
    </new-perseu-card>
    <new-perseu-card
      v-if="!isMainPlanPastRenewal"
      title="Assinaturas Adicionais"
      class="mt-3"
    >
      <div class="body-1">
        <v-list v-if="addonSubscriptions.length > 0" class="mx-2 mx-md-4 mb-6">
          <v-list-item
            v-for="addon in addonSubscriptions"
            :key="addon.planId"
            class="border-bottom-grey mb-3 px-2"
          >
            <v-list-item-content>
              <!-- Layout responsivo para addon items -->
              <div
                class="d-flex flex-column flex-md-row align-start align-md-center justify-space-between"
              >
                <!-- Informações do addon -->
                <div
                  class="d-flex flex-column flex-md-row align-start align-md-center mb-3 mb-md-0 full-width-mobile"
                >
                  <div
                    style="color: rgba(0, 0, 0, 0.6); min-width: 330px"
                    class="flex-grow-1"
                  >
                    <div class="font-weight-bold body-1">
                      {{
                        addon.status === "TRIALING" || addon.lastPrice === "0"
                          ? addon.planName + " (Período avaliação)"
                          : addon.planName
                      }}
                    </div>
                    <div
                      v-if="
                        addon.status !== 'TRIALING' && addon.lastPrice !== '0'
                      "
                    >
                      <div class="body-2">
                        <b>{{ addon.lastPrice }}</b
                        >/mês
                      </div>
                      <div class="body-2 pt-2">
                        Início Assinatura:
                        {{ addon.createdAt | formatDateFriendly }}
                      </div>
                      <div class="body-2 font-weight-medium">
                        {{
                          addon.status === "CANCELED"
                            ? "Acesso liberado até:"
                            : "Próxima Renovação:"
                        }}
                        {{ addon.nextBillingTime | formatDateFriendly }}
                      </div>
                    </div>
                    <div v-else-if="addon.status !== 'TRIALING'">
                      <div class="body-2 pt-2">
                        Início Avaliação:
                        {{ addon.createdAt | formatDateFriendly }}
                      </div>
                      <div class="body-2 font-weight-medium">
                        Fim avaliação:
                        {{ addon.nextBillingTime | formatDateFriendly }}
                      </div>
                    </div>
                    <div v-else class="body-2 pt-2">
                      <div class="body-2 pt-2">
                        Início Avaliação:
                        {{ addon.createdAt | formatDateFriendly }}
                      </div>
                      <div class="body-2 font-weight-medium">
                        Efetivação assinatura:
                        {{ addon.nextBillingTime | formatDateFriendly }}
                      </div>
                    </div>
                  </div>
                  <!-- Status chip para mobile -->
                  <div
                    class="mt-2 mt-md-0 ml-md-4 align-self-start align-self-md-center"
                  >
                    <subscription-status-chip :status="addon.status" />
                  </div>
                </div>

                <!-- Botões de ação -->
                <div
                  class="d-flex flex-column flex-md-row align-stretch align-md-center full-width-mobile"
                >
                  <v-btn
                    v-if="addon.status !== 'CANCELED'"
                    text
                    :small="!$vuetify.breakpoint.xs"
                    :block="$vuetify.breakpoint.xs"
                    color="red lighten-3"
                    class="mb-2 mb-md-0"
                    @click="manageAddon(addon)"
                  >
                    Cancelar
                  </v-btn>
                  <v-btn
                    v-if="
                      addon.status === 'CANCELED' && addon.lastPrice !== '0'
                    "
                    rounded
                    :small="!$vuetify.breakpoint.xs"
                    :block="$vuetify.breakpoint.xs"
                    color="primary"
                    :disabled="isMainPlanCancelled || isMainPlanExpired"
                    @click="manageAddon(addon)"
                  >
                    <v-icon left :small="$vuetify.breakpoint.xs"
                      >mdi-refresh</v-icon
                    >
                    Reativar
                  </v-btn>
                </div>
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <div v-else class="text-center body-2 pa-4 grey--text">
          Você não possui assinaturas adicionais.
        </div>

        <div class="d-flex justify-center pa-2 mt-2">
          <v-btn
            v-if="!isMainPlanCancelled && !isMainPlanExpired"
            rounded
            elevation="3"
            :small="$vuetify.breakpoint.xs"
            :block="$vuetify.breakpoint.xs"
            color="primary"
            @click="redirectToAddonsPage"
          >
            <v-icon left :small="$vuetify.breakpoint.xs"
              >add_circle_outline</v-icon
            >
            <span class="d-none d-sm-inline"
              >Contratar Assinatura Adicional</span
            >
            <span class="d-inline d-sm-none">Nova Assinatura</span>
          </v-btn>
        </div>
      </div>
    </new-perseu-card>
    <new-perseu-card title="Histórico de inscrições" class="mt-3">
      <div v-if="groupedSubscriptionsHistory.length > 0">
        <!-- Desktop Table View -->
        <v-data-table
          v-if="!$vuetify.breakpoint.xs && !$vuetify.breakpoint.sm"
          :headers="historyHeaders"
          :items="groupedSubscriptionsHistory"
          :items-per-page="10"
          hide-default-footer
          class="elevation-0"
          show-expand
          :expanded.sync="expanded"
          :item-class="getItemClass"
        >
          <!-- Slot para customizar o botão de expansão -->
          <template v-slot:item.data-table-expand="{ item }">
            <v-btn
              v-if="item.hasAddons"
              icon
              small
              @click="toggleExpansion(item.subscriptionId)"
            >
              <v-icon>
                {{
                  isItemExpanded(!item.subscriptionId)
                    ? "mdi-chevron-up"
                    : "mdi-chevron-down"
                }}
              </v-icon>
            </v-btn>
          </template>

          <!-- Slot para mostrar indicador de plano principal -->
          <template v-slot:item.subscriptionId="{ item }">
            <div class="d-flex align-center">
              <v-icon
                v-if="item.isMainPlan"
                color="primary"
                size="16"
                class="mr-2"
              >
                mdi-star
              </v-icon>
              <v-icon
                v-else-if="item.isAddon && item.isOrphan"
                color="orange"
                size="16"
                class="mr-2"
              >
                mdi-alert-circle-outline
              </v-icon>
              <span>{{ item.subscriptionId }}</span>
            </div>
          </template>

          <template v-slot:item.productTypeFriendly="{ item }">
            <div class="d-flex align-center">
              <span v-if="item.isMainPlan" class="font-weight-bold">{{
                item.productTypeFriendly
              }}</span>
              <span
                v-else-if="item.isOrphan"
                class="font-weight-medium orange--text"
                >{{ item.productTypeFriendly }} (Sem vinculação)</span
              >
              <span v-else>{{ item.productTypeFriendly }}</span>
              <v-chip
                v-if="item.hasAddons"
                x-small
                color="primary"
                class="ml-2"
              >
                +{{ item.addons.length }}
                {{
                  item.addons.length > 1
                    ? "linhas adicionais"
                    : "linha adicional"
                }}
              </v-chip>
            </div>
          </template>

          <template v-slot:item.status="{ item }">
            <subscription-status-chip :status="item.status" />
          </template>

          <template v-slot:item.createdAt="{ item }">
            {{ item.createdAt | formatDateFriendly }}
          </template>

          <template v-slot:item.validUntil="{ item }">
            {{ item.validUntil | formatDateFriendly }}
          </template>

          <template v-slot:item.actions="{ item }">
            <v-menu offset-y left :close-on-content-click="true">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon small v-bind="attrs" v-on="on">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item @click="viewCharges(item)">
                  <v-list-item-icon class="mr-2">
                    <v-icon small>mdi-cash-multiple</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Visualizar cobranças</v-list-item-title>
                </v-list-item>
                <v-list-item @click="downloadReceipts(item)">
                  <v-list-item-icon class="mr-2">
                    <v-icon small>mdi-download</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Baixar Comprovantes</v-list-item-title>
                </v-list-item>
                <v-list-item @click="viewDetails(item)">
                  <v-list-item-icon class="mr-2">
                    <v-icon small>mdi-information-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Detalhes</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>

          <!-- Slot para expansão - mostra os addons -->
          <template v-slot:expanded-item="{ headers, item }">
            <td
              v-if="
                !!expanded &&
                expanded?.some((exp) => exp === item.subscriptionId)
              "
              :colspan="headers.length"
              class="pa-0"
            >
              <v-card v-if="item.hasAddons" flat class="ma-2">
                <v-card-title class="py-2 px-4 subtitle-2 grey lighten-4">
                  <v-icon small class="mr-2">mdi-package-variant-closed</v-icon>
                  Planos Adicionais Vinculados
                </v-card-title>
                <table class="v-table theme--light" style="width: 100%">
                  <tbody>
                    <tr
                      v-for="addon in item.addons"
                      :key="addon.subscriptionId"
                      class="addon-row"
                    >
                      <td class="py-2" style="text-align: left">
                        <div class="d-flex align-center">
                          <v-icon color="grey" size="14" class="mr-2"
                            >mdi-subdirectory-arrow-right</v-icon
                          >
                          {{ addon.productTypeFriendly }}
                        </div>
                      </td>
                      <td class="py-2" style="width: 20%; text-align: left">
                        {{ addon.createdAt | formatDateFriendly }}
                      </td>
                      <td class="py-2" style="width: 18%; text-align: left">
                        {{ addon.validUntil | formatDateFriendly }}
                      </td>
                      <td class="py-2" style="width: 20%; text-align: center">
                        <subscription-status-chip
                          :status="addon.status"
                          size="small"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </v-card>
            </td>
          </template>
        </v-data-table>

        <!-- Mobile Card View -->
        <div v-else class="mobile-subscription-history pa-2">
          <v-card
            v-for="item in groupedSubscriptionsHistory"
            :key="item.subscriptionId"
            class="mb-3 subscription-history-card"
            outlined
          >
            <v-card-title class="py-3 px-4">
              <div class="d-flex align-center justify-space-between full-width">
                <div class="d-flex align-center">
                  <v-icon
                    v-if="item.isMainPlan"
                    color="primary"
                    size="18"
                    class="mr-2"
                  >
                    mdi-star
                  </v-icon>
                  <v-icon
                    v-else-if="item.isAddon && item.isOrphan"
                    color="orange"
                    size="18"
                    class="mr-2"
                  >
                    mdi-alert-circle-outline
                  </v-icon>
                  <div>
                    <div class="subtitle-2 font-weight-bold">
                      <span v-if="item.isMainPlan">{{
                        item.productTypeFriendly
                      }}</span>
                      <span v-else-if="item.isOrphan" class="orange--text">{{
                        item.productTypeFriendly
                      }}</span>
                      <span v-else>{{ item.productTypeFriendly }}</span>
                    </div>
                    <div v-if="item.isOrphan" class="caption orange--text">
                      Sem vinculação
                    </div>
                  </div>
                </div>
                <v-btn
                  v-if="item.hasAddons"
                  icon
                  small
                  @click="toggleExpansion(item.subscriptionId)"
                >
                  <v-icon>
                    {{
                      isItemExpanded(item.subscriptionId)
                        ? "mdi-chevron-up"
                        : "mdi-chevron-down"
                    }}
                  </v-icon>
                </v-btn>
              </div>
            </v-card-title>

            <v-card-text class="pt-0 px-4 pb-3">
              <v-row no-gutters class="mb-2">
                <v-col cols="6">
                  <div class="caption grey--text">Iniciado em</div>
                  <div class="body-2">
                    {{ item.createdAt | formatDateFriendly }}
                  </div>
                </v-col>
                <v-col cols="6">
                  <div class="caption grey--text">Válido até</div>
                  <div class="body-2">
                    {{ item.validUntil | formatDateFriendly }}
                  </div>
                </v-col>
              </v-row>

              <v-row no-gutters class="mb-3">
                <v-col cols="6">
                  <div class="caption grey--text">Status</div>
                  <subscription-status-chip :status="item.status" />
                </v-col>
                <v-col v-if="item.hasAddons" cols="6">
                  <div class="caption grey--text">Adicionais</div>
                  <v-chip x-small color="primary">
                    +{{ item.addons.length }}
                    {{ item.addons.length > 1 ? "linhas" : "linha" }}
                  </v-chip>
                </v-col>
              </v-row>

              <!-- Botões de ação -->
              <div class="d-flex justify-end">
                <v-btn icon small class="mr-1" @click="viewCharges(item)">
                  <v-icon small>mdi-cash-multiple</v-icon>
                </v-btn>
                <v-btn icon small class="mr-1" @click="downloadReceipts(item)">
                  <v-icon small>mdi-download</v-icon>
                </v-btn>
                <v-btn icon small @click="viewDetails(item)">
                  <v-icon small>mdi-information-outline</v-icon>
                </v-btn>
              </div>
            </v-card-text>

            <!-- Expansão para addons em mobile -->
            <v-expand-transition>
              <div
                v-if="item.hasAddons && isItemExpanded(item.subscriptionId)"
                class="addon-expansion-mobile"
              >
                <v-divider></v-divider>
                <v-card-title class="py-2 px-4 subtitle-2 grey lighten-4">
                  <v-icon small class="mr-2">mdi-package-variant-closed</v-icon>
                  Planos Adicionais Vinculados
                </v-card-title>
                <v-card-text class="px-4 py-2">
                  <v-card
                    v-for="addon in item.addons"
                    :key="addon.subscriptionId"
                    outlined
                    class="mb-2 addon-card"
                  >
                    <v-card-text class="pa-3">
                      <div class="d-flex align-center mb-2">
                        <v-icon color="grey" size="14" class="mr-2">
                          mdi-subdirectory-arrow-right
                        </v-icon>
                        <span class="subtitle-2 font-weight-medium">
                          {{ addon.productTypeFriendly }}
                        </span>
                      </div>
                      <v-row no-gutters>
                        <v-col cols="6">
                          <div class="caption grey--text">Iniciado</div>
                          <div class="body-2">
                            {{ addon.createdAt | formatDateFriendly }}
                          </div>
                        </v-col>
                        <v-col cols="6">
                          <div class="caption grey--text">Válido até</div>
                          <div class="body-2">
                            {{ addon.validUntil | formatDateFriendly }}
                          </div>
                        </v-col>
                      </v-row>
                      <div class="mt-2">
                        <subscription-status-chip
                          :status="addon.status"
                          size="small"
                        />
                      </div>
                    </v-card-text>
                  </v-card>
                </v-card-text>
              </div>
            </v-expand-transition>
          </v-card>
        </div>
      </div>
      <empty-list v-else />
    </new-perseu-card>

    <!-- Modal de confirmação para cancelamento de addon -->
    <v-dialog
      v-model="confirmDialog"
      :max-width="$vuetify.breakpoint.xs ? '90vw' : '500'"
      persistent
    >
      <v-card class="addon-cancel-dialog" elevation="24">
        <!-- Header -->
        <div class="dialog-header pa-4 pa-md-6">
          <div class="d-flex flex-column flex-md-row align-center">
            <v-avatar
              color="red lighten-5"
              :size="$vuetify.breakpoint.xs ? '48' : '56'"
              class="mr-0 mr-md-4 mb-3 mb-md-0"
            >
              <v-icon
                color="red darken-2"
                :size="$vuetify.breakpoint.xs ? '24' : '28'"
              >
                mdi-alert-circle-outline
              </v-icon>
            </v-avatar>
            <div class="text-center text-md-left">
              <h3 class="text-subtitle-1 text-md-h6 font-weight-bold mb-1 mt-2">
                Cancelar assinatura adicional
              </h3>
            </div>
          </div>
        </div>

        <!-- Content -->
        <v-card-text class="pa-4 pa-md-6">
          <div
            class="addon-info mb-6 mb-md-8 pa-3 pa-md-4"
            style="background-color: #f5f5f5; border-radius: 8px"
          >
            <div
              class="d-flex flex-column flex-md-row align-start align-md-center"
            >
              <v-icon
                color="primary"
                class="mr-0 mr-md-3 mb-2 mb-md-0 align-self-center"
                >mdi-package-variant</v-icon
              >
              <div class="text-center text-md-left">
                <div class="font-weight-bold body-1">
                  {{ selectedAddon && selectedAddon.planName }}
                </div>
                <div
                  v-if="selectedAddon && selectedAddon.status !== 'TRIALING'"
                  class="body-2 grey--text"
                >
                  {{ selectedAddon.lastPrice }}/mês
                </div>
              </div>
            </div>
          </div>

          <div class="text-body-2 text-md-body-1 mb-4 mb-md-6">
            {{ confirmMessage }}
          </div>

          <!-- Informações sobre o cancelamento -->
          <v-alert
            outlined
            color="orange"
            icon="mdi-information-outline"
            class="mb-0"
          >
            <div
              v-if="selectedAddon && selectedAddon.status !== 'TRIALING'"
              class="caption body-2-mobile"
            >
              <ul class="cancel-info-list">
                <li class="mb-1">
                  A linha de rastreio permanecerá ativa até o final do período
                  de cobrança atual em
                  <b>
                    {{
                      selectedAddon &&
                      selectedAddon.nextBillingTime | formatDateFriendly
                    }}.
                  </b>
                </li>
                <li class="mb-1">
                  Você não será cobrado novamente por esta linha.
                </li>
                <li class="primary--text">
                  Você poderá assinar novamente essa linha quando desejar.
                </li>
              </ul>
            </div>
            <div v-else class="caption body-2-mobile">
              <ul class="cancel-info-list">
                <li class="mb-1">
                  Seu acesso á esta linha está garantido até o fim do período de
                  avaliação gratuita, que terminará em
                  <b>
                    {{
                      selectedAddon &&
                      selectedAddon.nextBillingTime | formatDateFriendly
                    }}.
                  </b>
                </li>
                <li class="mb-1">
                  Você não será cobrado quando o período de avaliação terminar.
                </li>
                <li class="primary--text">
                  Você poderá assinar novamente essa linha após o fim do período
                  de avaliação.
                </li>
              </ul>
            </div>
          </v-alert>
        </v-card-text>

        <!-- Actions -->
        <v-card-actions
          class="dialog-actions pa-4 pa-md-6 pt-2 d-flex flex-column flex-md-row justify-space-between"
        >
          <v-btn
            rounded
            text
            :small="$vuetify.breakpoint.xs"
            :block="$vuetify.breakpoint.xs"
            color="primary"
            :disabled="cancelingAddon"
            class="mb-2 mb-md-0 order-2 order-md-1"
            @click="cancelConfirm"
          >
            Manter assinatura
          </v-btn>
          <v-btn
            rounded
            elevation="3"
            :small="$vuetify.breakpoint.xs"
            :block="$vuetify.breakpoint.xs"
            color="red"
            :loading="cancelingAddon"
            class="order-1 order-md-2"
            @click="confirmAction"
          >
            <v-icon left :small="$vuetify.breakpoint.xs">mdi-cancel</v-icon>
            <span class="d-none d-sm-inline">Quero cancelar</span>
            <span class="d-inline d-sm-none">Cancelar</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  renewLoggedUser,
  getSubscriptionsHistory,
  cancelAddonSubscription, // Nova importação
  reactivateAddonSubscription, // NOVO
} from "@/services/external/paypal-service";
import { sendError } from "@/services/external/paypal-service";
import db from "@/database";
import dayjs from "dayjs";

export default {
  name: "MySubscriptionNew",
  components: {
    SubscriptionStatusChip: () =>
      import(
        "@/domains/subscriptions/presentation/components/SubscriptionStatusChip"
      ),
  },
  data() {
    return {
      subscriptionData: {},
      subscriptionsHistory: [],
      additionalSubscriptions: [],
      addonSubscriptions: [], // Novo campo para addons
      expanded: [], // Para controlar quais linhas estão expandidas

      // Variáveis para o modal de confirmação
      confirmDialog: false,
      confirmTitle: "",
      confirmMessage: "",
      confirmOkText: "Confirmar",
      confirmCancelText: "Cancelar",
      confirmButtonColor: "primary",
      confirmCallback: null,

      // Variáveis para o modal de confirmação de addon
      selectedAddon: null,
      cancelingAddon: false,
    };
  },
  computed: {
    userPhoto() {
      return (
        this.$store.getters["login/photo"] || require("@/assets/no-photo.svg")
      );
    },
    userName() {
      return this.$store.getters["login/userName"];
    },
    isMainPlanCancelled() {
      return this.subscriptionData.status === "CANCELED";
    },
    isMainPlanTrialing() {
      return this.subscriptionData.status === "TRIALING";
    },
    isMainPlanExpired() {
      return this.subscriptionData.status === "EXPIRED";
    },
    canRenewMainSubscription() {
      return (
        (this.subscriptionData.status === "CANCELED" ||
          this.subscriptionData.status === "EXPIRED") &&
        this.subscriptionData.nextBillingTime &&
        dayjs().isAfter(dayjs(this.subscriptionData.nextBillingTime))
      );
    },

    isMainPlanPastRenewal() {
      if (!this.subscriptionData?.nextBillingTime) {
        return true;
      }
      const now = dayjs();
      const nextBilling = dayjs(this.subscriptionData.nextBillingTime);
      return now.isAfter(nextBilling);
    },

    // Headers responsivos para a tabela
    historyHeaders() {
      const baseHeaders = [
        { text: "Plano", value: "productTypeFriendly", sortable: true },
        { text: "Iniciado em", value: "createdAt", sortable: true },
        { text: "Válido até", value: "validUntil", sortable: true },
        { text: "Status", value: "status", sortable: true, align: "center" },
      ];

      return baseHeaders;
    },

    // Nova propriedade computada para agrupar assinaturas
    groupedSubscriptionsHistory() {
      const grouped = [];
      const processedAddons = new Set();

      // Ordenar subscriptionsHistory por nextBillingTime (mais recente) e depois por createdAt (mais recente)
      const sortedHistory = [...this.subscriptionsHistory].sort((a, b) => {
        // Primeiro, ordenar por nextBillingTime (desc) - valores nulos vão para o final
        const aNextBilling = a.nextBillingTime
          ? dayjs(a.nextBillingTime).valueOf()
          : 0;
        const bNextBilling = b.nextBillingTime
          ? dayjs(b.nextBillingTime).valueOf()
          : 0;

        if (aNextBilling !== bNextBilling) {
          return bNextBilling - aNextBilling;
        }

        // Se nextBillingTime for igual (ou ambos nulos), ordenar por createdAt (desc)
        const aCreated = dayjs(a.createdAt).valueOf();
        const bCreated = dayjs(b.createdAt).valueOf();
        return bCreated - aCreated;
      });

      // Primeiro, adiciona todos os planos principais
      const mainPlans = sortedHistory.filter((item) => item.isMainPlan);

      mainPlans.forEach((mainPlan) => {
        const groupedItem = {
          ...mainPlan,
          isMainPlan: true,
          hasAddons: false,
          addons: [],
        };

        // Busca addons vinculados a este plano principal
        const relatedAddons = sortedHistory.filter(
          (item) =>
            !item.isMainPlan &&
            item.parentSubscriptionId === mainPlan.subscriptionId &&
            !processedAddons.has(item.subscriptionId)
        );

        if (relatedAddons.length > 0) {
          groupedItem.hasAddons = true;
          groupedItem.addons = relatedAddons.map((addon) => ({
            ...addon,
            isAddon: true,
            parentId: mainPlan.subscriptionId,
          }));

          // Marca os addons como processados
          relatedAddons.forEach((addon) => {
            processedAddons.add(addon.subscriptionId);
          });
        }

        grouped.push(groupedItem);
      });

      // Adiciona planos adicionais sem vinculação (órfãos)
      const orphanAddons = sortedHistory.filter(
        (item) => !item.isMainPlan && !processedAddons.has(item.subscriptionId)
      );

      orphanAddons.forEach((addon) => {
        grouped.push({
          ...addon,
          isAddon: true,
          isOrphan: true,
          parentId: null,
        });
      });

      return grouped;
    },
  },

  created() {
    this.fillSubscriptionsHistory();
    if (this.$route.query.success === "true") {
      this.refreshUserDataAndSubscriptions();
    } else if (this.$route.query.success === "false") {
      this.onSubscriptionFailure("Erro ao realizar assinatura stripe!");
    }
  },

  methods: {
    async onSubscriptionFailure(error) {
      // await sendError(error);
      this.$errorAlert({
        title: "Erro ao realizar pagamento",
        message: "O pagamento não foi realizado. Tente novamente mais tarde.",
      });
    },
    async refreshUserDataAndSubscriptions() {
      try {
        this.$store.dispatch("loading/openDialog");
        const { data } = await renewLoggedUser();
        this.$store.commit("login/set", data);
        this.$successAlert({
          title: "Plano ativado",
          message: "Comece a utilizar as funcionalidades agora mesmo",
        });
        this.$router.push({ name: "home" });
      } catch (error) {
        await sendError(error.stack);
        this.$warningAlert({
          message:
            "Seu pagamento foi realizado, mas algo aconteceu de errado. Já reportamos o erro para que seja solucionado o mais breve possível.",
        });
      } finally {
        this.$store.dispatch("loading/closeDialog");
      }
    },

    async fillSubscriptionsHistory() {
      try {
        this.$store.dispatch("loading/openDialog");
        const { data } = await getSubscriptionsHistory();

        this.subscriptionData =
          data.find((item) => item.isCurrenSubscription) || {};

        // Verifica se existe subscriptionId antes de usar startsWith
        if (this.subscriptionData.subscriptionId) {
          this.subscriptionData.isManualSubscription =
            !this.subscriptionData.subscriptionId.startsWith("I-") &&
            !this.subscriptionData.subscriptionId.startsWith("sub_");
        }

        this.addonSubscriptions = data
          .filter(
            (item) =>
              this.subscriptionData.subscriptionId &&
              this.subscriptionData.subscriptionId === item.parentSubscriptionId
          )
          .filter((item) => {
            if (item.status === "CANCELED" && !!item.nextBillingTime) {
              const now = dayjs();
              const nextBilling = dayjs(item.nextBillingTime);
              return now.isBefore(nextBilling);
            } else {
              return (
                item.status === "ACTIVE" ||
                item.status === "EXPIRED" ||
                item.status === "TRIALING"
              );
            }
          });

        this.subscriptionsHistory = data;
        this.expanded = [...data];
      } catch (e) {
        this.$errorHandler(e);
      } finally {
        this.$store.dispatch("loading/closeDialog");
      }
    },
    redirectToPlansPage() {
      this.$router.push({ name: "subscriptions.plans" });
    },
    redirectToAddonsPage() {
      this.$router.push({ name: "subscriptions.addons" });
    },
    cancelSubscription() {
      this.$router.push({
        name: "subscriptions.cancellation",
        query: { validUntil: this.subscriptionData.nextBillingTime },
      });
    },
    viewCharges(subscription) {
      // console.log("Visualizar cobranças da assinatura:", subscription);
      this.$router.push({
        name: "subscriptions.charges",
        params: {
          id: subscription.subscriptionId,
        },
      });
    },
    downloadReceipts(subscription) {
      // console.log("Baixar comprovantes da assinatura:", subscription);
    },
    viewDetails(subscription) {
      // console.log("Ver detalhes da assinatura:", subscription);
      this.$router.push({
        name: "subscriptions.details",
        params: {
          id: subscription.subscriptionId,
        },
      });
    },
    // Método personalizado para confirmação
    showConfirm(message, options = {}) {
      return new Promise((resolve) => {
        this.confirmTitle = options.title || "Confirmação";
        this.confirmMessage = message;
        this.confirmOkText = options.buttonTrueText || "Confirmar";
        this.confirmCancelText = options.buttonFalseText || "Cancelar";
        this.confirmButtonColor = options.buttonTrueColor || "primary";
        this.confirmCallback = resolve;
        this.confirmDialog = true;
      });
    },
    confirmAction() {
      this.confirmDialog = false;
      if (this.confirmCallback) {
        this.confirmCallback(true);
        this.confirmCallback = null;
      }
    },
    getConfirmIcon() {
      const iconMap = {
        error: "mdi-alert-circle",
        warning: "mdi-alert",
        success: "mdi-check-circle",
        info: "mdi-information",
        primary: "mdi-help-circle",
      };
      return iconMap[this.confirmButtonColor] || "mdi-help-circle";
    },

    getConfirmIconColor() {
      const colorMap = {
        error: "red lighten-5",
        warning: "orange lighten-5",
        success: "green lighten-5",
        info: "blue lighten-5",
        primary: "blue lighten-5",
      };
      return colorMap[this.confirmButtonColor] || "blue lighten-5";
    },

    getConfirmIconTextColor() {
      const colorMap = {
        error: "red darken-2",
        warning: "orange darken-2",
        success: "green darken-2",
        info: "blue darken-2",
        primary: "blue darken-2",
      };
      return colorMap[this.confirmButtonColor] || "blue darken-2";
    },

    cancelConfirm() {
      this.confirmDialog = false;
      if (this.confirmCallback) {
        this.confirmCallback(false);
        this.confirmCallback = null;
      }
    },
    getItemClass(item) {
      return item.hasAddons ? "" : "no-expand";
    },
    toggleExpansion(subscriptionId) {
      console.log("Linhas expandidas:", this.expanded);

      const index = this.expanded.findIndex((exp) => exp === subscriptionId);

      if (index > -1) {
        // Remove do array se já estiver expandido
        this.expanded = this.expanded.filter((exp) => exp !== subscriptionId);
      } else {
        // Adiciona ao array se não estiver expandido
        this.expanded.push(subscriptionId);
      }
    },
    isItemExpanded(subscriptionId) {
      return this.expanded.some((exp) => exp === subscriptionId);
    },
    async manageAddon(addon) {
      if (addon.status === "CANCELED") {
        const isOutOfCurrentCycle =
          !addon.nextBillingTime ||
          dayjs().isAfter(dayjs(addon.nextBillingTime));

        let message = `
          <div style="text-align:left">
            <p><strong>Reativando agora:</strong> a cobrança voltará na próxima fatura, junto com a assinatura principal.</p>
          </div>
        `;

        if (isOutOfCurrentCycle) {
          message = `
            <p><strong>Reativando agora:</strong> será gerada uma fatura do valor proporcional deste mês, para os próximos meses a cobrança será junto com a assinatura principal.</p>
          `;
        }

        const result = await this.$swal({
          title: "Reativar linha de rastreio?",
          html: message,
          icon: "question",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonText: "Reativar",
          confirmButtonColor: "#4caf50",
        });

        if (result.isConfirmed) {
          await this.processReactivateAddon(addon);
        }
        return;
      }

      this.selectedAddon = addon;
      this.confirmMessage = `Tem certeza que deseja cancelar essa linha de rastreio?`;
      this.confirmCallback = async (confirmed) => {
        if (confirmed) {
          await this.processCancelAddon(addon.subscriptionId);
        }
      };
      this.confirmDialog = true;
    },

    async processReactivateAddon(addon) {
      try {
        this.$store.dispatch("loading/openDialog");
        await reactivateAddonSubscription(addon.subscriptionId);

        this.$successAlert({
          title: "Reativado",
          message: `A linha "${addon.planName}" foi reativada. Cobrança retomará no próximo ciclo.`,
        });

        await this.fillSubscriptionsHistory();

        await db.open();
        await db.config.clear();
      } catch (e) {
        this.$errorHandler(e);
      } finally {
        this.$store.dispatch("loading/closeDialog");
      }
    },

    async processCancelAddon(subscriptionId) {
      try {
        this.cancelingAddon = true;
        this.$store.dispatch("loading/openDialog");

        await cancelAddonSubscription(subscriptionId);

        this.$successAlert({
          title: "Linha de rastreio cancelada",
          message: `A linha de rastreio "${this.selectedAddon.planName}" foi cancelada com sucesso.`,
        });

        await this.fillSubscriptionsHistory();

        await db.open();
        await db.config.clear();
      } catch (e) {
        this.$errorHandler(e);
      } finally {
        this.$store.dispatch("loading/closeDialog");
        this.cancelingAddon = false;
      }
    },
  },
};
</script>

<style scoped>
/* Estilos para as linhas de addons */
.addon-row {
  background-color: #fafafa;
  border-left: 3px solid #e3f2fd;
}

.addon-row:hover {
  background-color: #f0f8ff;
}

.addon-row td {
  font-size: 0.875rem;
  color: #666;
  padding-left: 16px !important;
  padding-right: 16px !important;
}

/* Alinhamento específico para a tabela de addons */
.addon-row td:first-child {
  padding-left: 24px !important; /* Extra padding para o ícone de seta */
}

/* Esconde o botão de expansão para itens sem addons */
.no-expand .v-data-table__expand-icon {
  display: none !important;
}

.confirm-dialog {
  border-radius: 12px !important;
  overflow: hidden;
}

.confirm-dialog__header {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.confirm-dialog__content {
  min-height: 80px;
  background: #ffffff;
}

.confirm-dialog__actions {
  background: #fafafa;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}

.line-height-relaxed {
  line-height: 1.6;
}

/* Animação suave para o diálogo */
.v-dialog__content--active {
  align-items: center;
}

/* Melhorar aparência dos botões */
.confirm-dialog__actions .v-btn {
  text-transform: none !important;
  letter-spacing: 0.5px;
  border-radius: 8px !important;
  min-width: 100px;
}

.confirm-dialog__actions .v-btn--outlined {
  border-width: 1.5px !important;
}

/* Responsividade */
@media (max-width: 600px) {
  .confirm-dialog {
    margin: 16px;
  }
  .confirm-dialog__header {
    padding: 20px !important;
  }
  .confirm-dialog__content {
    padding: 20px !important;
  }
  .confirm-dialog__actions {
    padding: 20px !important;
    padding-top: 0 !important;
  }
  .confirm-dialog__actions .v-btn {
    min-width: 80px;
  }
}

/* Responsividade geral */
@media (max-width: 768px) {
  .full-width-mobile {
    width: 100% !important;
  }

  .body-2-mobile {
    font-size: 0.875rem !important;
  }

  /* Melhor espaçamento em mobile */
  .v-card__text {
    padding: 16px !important;
  }

  .v-list-item__content {
    padding: 8px 0 !important;
  }

  /* Ajustes para botões em mobile */
  .v-btn--block {
    margin-bottom: 8px;
  }

  .v-btn--block:last-child {
    margin-bottom: 0;
  }
}

@media (max-width: 600px) {
  /* Reduzir padding em telas muito pequenas */
  .mx-2 {
    margin-left: 8px !important;
    margin-right: 8px !important;
  }

  .px-2 {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }

  /* Ajustar fonte em mobile */
  .text-h6 {
    font-size: 1.125rem !important;
  }

  .text-subtitle-1 {
    font-size: 1rem !important;
  }
}

/* Ajustes específicos para tabela em mobile */
@media (max-width: 768px) {
  .v-data-table__mobile-row {
    min-height: auto !important;
    padding: 16px !important;
  }

  .v-data-table__mobile-row__header {
    font-weight: 600 !important;
    margin-bottom: 4px !important;
  }

  .v-data-table__mobile-row__cell {
    text-align: left !important;
    padding-left: 0 !important;
  }
}

/* Melhorar o avatar do ícone */
.confirm-dialog__header .v-avatar {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* Estilos específicos para o modal de cancelamento de addon */
.addon-cancel-dialog {
  border-radius: 16px !important;
  overflow: hidden;
}

.addon-info {
  border-left: 4px solid #1976d2;
}

.dialog-actions .v-btn {
  text-transform: none !important;
  letter-spacing: 0.5px;
  border-radius: 8px !important;
  min-width: 120px;
  font-weight: 500;
}

.dialog-actions .v-btn--outlined {
  border-width: 1.5px !important;
}

/* Animação suave para entrada do modal */
.v-dialog__content {
  align-items: center;
}

/* Avatar com sombra suave */
.dialog-header .v-avatar {
  box-shadow: 0 2px 12px rgba(244, 67, 54, 0.15);
}

/* Responsividade para mobile */
@media (max-width: 600px) {
  .addon-cancel-dialog {
    margin: 16px;
    border-radius: 12px !important;
  }
  .dialog-header {
    padding: 20px !important;
  }
  .dialog-actions {
    padding: 20px !important;
    padding-top: 0 !important;
  }
  .dialog-actions .v-btn {
    min-width: 100px;
    padding: 8px 16px !important;
  }
}

/* Hover effects para os botões */
.dialog-actions .v-btn:hover {
  transform: translateY(-1px);
  transition: transform 0.2s ease;
}

.cancel-info-list {
  padding-left: 0px;
  margin-left: 16px;
  margin-top: 2px;
  list-style-type: disclosure-closed;
  cursor: default;
}

/* Estilos para cards mobile do histórico */
.mobile-subscription-history {
  max-width: 100%;
}

.subscription-history-card {
  border-radius: 12px !important;
  transition: all 0.3s ease;
}

.subscription-history-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

.subscription-history-card .v-card__title {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.full-width {
  width: 100%;
}

.addon-expansion-mobile {
  background-color: #fafafa;
}

.addon-card {
  background-color: #ffffff !important;
  border-radius: 8px !important;
  border: 1px solid #e0e0e0 !important;
}

.addon-card:last-child {
  margin-bottom: 0 !important;
}

/* Melhorar aparência dos chips em mobile */
@media (max-width: 600px) {
  .subscription-history-card .v-chip {
    font-size: 0.75rem !important;
    height: 20px !important;
  }

  .subscription-history-card .v-chip--x-small {
    height: 18px !important;
    font-size: 0.7rem !important;
  }

  .subscription-history-card .v-icon {
    font-size: 16px !important;
  }

  .subscription-history-card .v-card__title {
    padding: 12px 16px !important;
  }

  .subscription-history-card .v-card__text {
    padding: 0 16px 12px 16px !important;
  }
}
</style>
